import React from 'react';
import styled from 'styled-components';
import { PaymentIcon, PaymentType } from 'react-svg-credit-card-payment-icons';

const brandNames: Record<string, string> = {
  visa: 'Visa',
  mastercard: 'MasterCard',
  amex: 'Amex',
  elo: 'Elo',
  aura: 'Aura',
  jcb: 'JCB',
  diners: 'Diners',
  discover: 'Discover',
  hipercard: 'Hipercard',
};

export const getBrandName = (code: string) => brandNames[code] ?? code;

interface CardBrandProps {
  code: string;
}

const CardBrand = ({ code }: CardBrandProps) => (
  <MarginSpan>
    <PaymentIcon type={code as PaymentType} format='flatRounded' width={25} />
  </MarginSpan>
);

const MarginSpan = styled.span`
  margin-right: 5px;
`;

export default CardBrand;
